import script from "./messageContainer.vue?vue&type=script&setup=true&name=messageContainer&lang=js"
export * from "./messageContainer.vue?vue&type=script&setup=true&name=messageContainer&lang=js"

import "./messageContainer.vue?vue&type=style&index=0&id=1543b482&scoped=true&lang=css"

import exportComponent from "D:\\Jawsro\\company\\虎鲸\\v3\\hujing_pro_h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1543b482"]])

export default __exports__